import { FormattedMessage } from "react-intl";
// import moment from "moment";
import dayjs from "dayjs";
import { Select, DatePicker } from "antd";
import timezoneList from "../data/timezone.json";

const { RangePicker } = DatePicker;
const { Option } = Select;

const Topbar = (props) => {
  const { date, daySelected, timezone, filterDate, filterTimezone } = props;
  return (
    <div className="col-12 d-flex flex-column flex-lg-row justify-content-between align-items-center mb-4">
      {/* Day Selection */}
      <div className="day_selection d-flex flex-row flex-wrap justify-content-center">
        <div
          className={`filter_day ${daySelected === "today" ? "selected" : ""}`}
          onClick={() => filterDate([dayjs(), dayjs()], "today")}
        >
          <FormattedMessage id="commons.today" />
        </div>
        <div
          className={`filter_day ${daySelected === "tmr" ? "selected" : ""}`}
          onClick={() =>
            filterDate(
              [dayjs().add(1, "days"), dayjs().add(1, "days")],
              "tmr"
            )
          }
        >
          <FormattedMessage id="commons.tomorrow" />
        </div>
        <div
          className={`filter_day ${
            daySelected === "this_week" ? "selected" : ""
          }`}
          onClick={() =>
            filterDate(
              [dayjs().startOf("week"), dayjs().endOf("week")],
              "this_week"
            )
          }
        >
          <FormattedMessage id="commons.this_week" />
        </div>
        <div
          className={`filter_day ${
            daySelected === "next_week" ? "selected" : ""
          }`}
          onClick={() =>
            filterDate(
              [
                dayjs().startOf("week").add(7, "days"),
                dayjs().endOf("week").add(7, "days"),
              ],
              "next_week"
            )
          }
        >
          <FormattedMessage id="commons.next_week" />
        </div>
        <div
          className={`filter_day ${
            daySelected === "this_month" ? "selected" : ""
          }`}
          onClick={() =>
            filterDate(
              [dayjs().startOf("month"), dayjs().endOf("month")],
              "this_month"
            )
          }
        >
          <FormattedMessage id="commons.this_month" />
        </div>
        <div
          className={`filter_day ${
            daySelected === "next_month" ? "selected" : ""
          }`}
          onClick={() =>
            filterDate(
              [
                dayjs().startOf("month").add(1, "months"),
                dayjs().endOf("month").add(1, "months"),
              ],
              "next_month"
            )
          }
        >
          <FormattedMessage id="commons.next_month" />
        </div>
      </div>
      {/* Date Range Selection  */}
      <div className="my-3 my-lg-0">
        <RangePicker
          value={date}
          format="YYYY-MM-DD"
          onChange={(values, formatString) => filterDate(values)}
        />
      </div>
      {/* Timezone Selection */}
      <div className="timezone_selection text-center">
        <Select
          value={timezone}
          onChange={filterTimezone}
          showSearch
          optionFilterProp="children"
          filterOption={(input, option) =>
            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
          }
        >
          {timezoneList.map((item, index) => (
            <Option value={item.value} key={index}>
              {item.label}
            </Option>
          ))}
        </Select>
      </div>
    </div>
  );
};

export default Topbar;
